import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import App from "./pages/App";
import Login from "./pages/auth/login/login.page";
import SignUpPage from "./pages/auth/signup/signup.page";

import ProgressInfo from "./components/progressInfo/ProgressInfo";
import ActivateAccountPage from "./pages/auth/activate-account/activate.account.page";
import ResetPasswordPage from "./pages/auth/reset-password/reset.password.page";
import applicationComander from "./store/commanders/application.comander";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ForgotPasswordPage from "./pages/auth/forgot-password/forgot.password.page";
import NavbarComponent from "./components/navbar/navbar.component";
import ChangePasswordPage from "./pages/auth/new-password/new-password";
import LoaderComponent from "./components/loader/loader.cmp";
import ReactGA4 from "react-ga4";
import { Hub } from "aws-amplify";
import navigationService from "./services/navigation/navigation.service";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AppContent = () => {
  const { t } = useTranslation();
  const appState = useSelector((state: any) => state.application);
  const user = useSelector((state: any) => state.application.user);
  const userData = useSelector((state: any) => state.account.userData);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    navigationService.setHistory(history);
  }, [history]);
  useEffect(() => {
    ReactGA4.initialize("G-D9F7Y6V1GD");
    const unsubscribe = Hub.listen("auth", async ({ payload }) => {
      switch (payload.event) {
        case "signIn":
          // you can dispatch user info into redux
          applicationComander.cmd_autoLogIn();
          break;
        case "signOut":
          // console.log("🚪 Signed out");
          // applicationComander.cmd_clearUser();
          break;
        case "signIn_failure":
          console.error("❌ Sign in failed:", payload.data);
          break;
        default:
          break;
      }
    });
    applicationComander.cmd_autoLogIn();
    return unsubscribe;
  }, []);

  const loading = useSelector((state: any) => state.application.loading);
  const overlayLoading = useSelector(
    (state: any) => state.application.overlayLoading
  );

  const isInitialising =
    // accountData === undefined ||
    loading || overlayLoading;

  return (
    <>
      <a className="skip-link" href="#main-content">
        {t("accessibility.skipToContent")}
      </a>
      <ToastContainer position="top-right" autoClose={1500} theme={"dark"} />

      {isInitialising ? (
        <LoaderComponent loading overlayLoading={false}></LoaderComponent>
      ) : null}
      <NavbarComponent user={user} userData={userData} />
      <main id="main-content" tabIndex={-1}>
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/signup" component={SignUpPage} />
          <Route
            path="/activate"
            render={(props) => <ActivateAccountPage {...props} />}
          />
          <Route
            path="/new-password"
            render={(props) => <ChangePasswordPage {...props} />}
          />
          <Route
            path="/forgot-password"
            render={(props) => <ForgotPasswordPage {...props} />}
          />
          <Route
            path="/reset-password"
            render={(props) => <ResetPasswordPage {...props} />}
          />
          {/*//@ts-ignore */}
          <ProtectedRoute path="*" component={App} />
        </Switch>
      </main>
      <ProgressInfo />
    </>
  );
};

const Main = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default Main;
